/* eslint-disable no-console */
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import Beep from "utilities/beep";

import en from "./en";
import enGB from "./en-GB";

const SUPPORTED_LANGUAGES = ["en", "en-GB"];

export const detectInitialLanguage = (): string => {
  const userLang = navigator.language || "en";
  if (userLang.toLowerCase().startsWith("en-gb")) {
    return "en-GB";
  }
  return SUPPORTED_LANGUAGES.includes(userLang) ? userLang : "en";
};

export default async (locale?: string): Promise<unknown> => {
  if (!i18n.isInitialized) {
    await i18n
      .use(HttpBackend)
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        fallbackLng: "en",
        supportedLngs: SUPPORTED_LANGUAGES,
        lng: detectInitialLanguage(),
        debug: false, // change to true to see logs
        resources: {
          en,
          "en-GB": enGB,
        },
        interpolation: {
          escapeValue: false,
        },
        saveMissing: true,
        // backend: {
        //     loadPath: "/api/translations/{{lng}}.json",
        // },
        missingKeyHandler: (lngs, ns, key) => {
          const [group, ...rest] = key.split(".");
          void Beep();
          console.error(
            `Missing translation:      
            Languages: ${lngs}
            Namespace: ${ns}
            Group: ${group}
            Key: ${rest.join(".")}\n`
          );
        },
      });

    // If we implement backend overrides, we can implement something like this:
    /*
      await fetch(`/api/translations/${i18n.language}-overrides.json`)
        .then((res) => (res.ok ? res.json() : {}))
        .then((override) => {
            if (override && Object.keys(override).length) {
              i18n.addResources(i18n.language, "translation", override);
            }
          });
    */
  } else {
    await i18n.changeLanguage(locale);
    return Promise.resolve();
  }
};

export const formatList = (
  items: string[],
  {
    type = "conjunction", // or "disjunction" for "or"
    style = "long", // "long" | "short" | "narrow"
  }: {
    type?: "conjunction" | "disjunction";
    style?: "long" | "short" | "narrow";
  } = {}
): string => {
  const locale = i18n.language || "en";
  const formatter = new Intl.ListFormat(locale, { style, type });
  return formatter.format(items);
};
